import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { BaseOneToOneConversation } from "./OneToOneConversation/index.jsx";
import { getLoggedUserId } from "../../../../../store/selectors/selector.users.jsx";

export const OneToOneConversation = ({ members, conversationId }) => {
  const loggedUserId = useSelector(getLoggedUserId);
  const id = useMemo(() => members.find((id) => id !== loggedUserId), [loggedUserId, members]);

  return (
    <BaseOneToOneConversation
      id={id}
      conversationId={conversationId}
      showHeaderMenu
    />
  );
};

OneToOneConversation.propTypes = {
  conversationId: PropTypes.number.isRequired,
  members: PropTypes.arrayOf(PropTypes.number),
};

OneToOneConversation.defaultProps = {
  members: [],
};
